/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Add_Tracking_Or_Local_PickupInputs */

const en_samples_add_tracking_or_local_pickup = /** @type {(inputs: Samples_Add_Tracking_Or_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a tracking number or mark as Local Pick Up`)
};

const es_samples_add_tracking_or_local_pickup = /** @type {(inputs: Samples_Add_Tracking_Or_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregue un numero de rastreo o marque como recogida local`)
};

/**
* | output |
* | --- |
* | "Add a tracking number or mark as Local Pick Up" |
*
* @param {Samples_Add_Tracking_Or_Local_PickupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_add_tracking_or_local_pickup = /** @type {((inputs?: Samples_Add_Tracking_Or_Local_PickupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Add_Tracking_Or_Local_PickupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_add_tracking_or_local_pickup(inputs)
	return es_samples_add_tracking_or_local_pickup(inputs)
});